import React from 'react'
import { Blockquote } from '@christies/react/components/Editorial'
import { SelectValue, withParsedContext } from '../../withJSSContext'
import { RenderFields } from '../../utils'

interface Props {
  parsedFields: {
    Text: string
    'Quote Primary Subcaption': string
    'Quote Secondary Subcaption': string
  }
  parsedRouteFields: {
    'Story Theme': SelectValue<'light' | 'dark'>
  }
}

const MagazinesQuoteModule: React.FC<Props> = ({ parsedFields, parsedRouteFields }) => {
  const blockquoteProps = {
    quote: parsedFields?.Text,
    author: parsedFields?.['Quote Primary Subcaption'],
    role: parsedFields?.['Quote Secondary Subcaption'],
    theme: parsedRouteFields?.['Story Theme']?.key,
  }

  return (
    <RenderFields parsedFields={parsedFields}>
      <Blockquote $align="center" {...blockquoteProps} />
    </RenderFields>
  )
}

export default withParsedContext(MagazinesQuoteModule as React.FC)
